import { ALL_CONFIGS } from '@/config';
import { BN } from '@coral-xyz/anchor';
import { fromBig, NATIVE_TOKEN_DECIMALS, toBN } from './util';

/**
 * Calculates the token price based on reserves and decimals
 */
export function calculateTokenPrice(
  tokenReserves: BN,
  lamportReserves: BN,
  tokenDecimals: number,
  solPriceinUSD?: number,
): number {
  const tokenReservesNum = toBN(tokenReserves?.toString() || '1').div(
    10 ** tokenDecimals,
  );
  const lamportReservesNum = toBN(lamportReserves?.toString() || '0').div(
    10 ** NATIVE_TOKEN_DECIMALS,
  );

  return toBN(solPriceinUSD || 1)
    .multipliedBy(lamportReservesNum)
    .div(tokenReservesNum)
    .toNumber();
}

/**
 * Calculates the King of the Hill progress
 */
export function calculateKotHProgress(
  lamportReserves: BN,
  bondingCurveLimit: BN,
  initCurve: number = ALL_CONFIGS.INIT_SOL_BONDING_CURVE,
): number {
  const reserves =
    lamportReserves instanceof BN ? lamportReserves : new BN(lamportReserves);
  const limit =
    bondingCurveLimit instanceof BN
      ? bondingCurveLimit
      : new BN(bondingCurveLimit);

  if (limit.toNumber() === 0) return 0;

  const calcLamportReserves = reserves.sub(new BN(initCurve));
  const calcBondingCurveLimit = limit.sub(new BN(initCurve));
  let progress =
    (fromBig(calcLamportReserves, 9) /
      (fromBig(calcBondingCurveLimit, 9) / 2)) *
    100;

  return Math.min(progress, 100);
}
